// extracted by mini-css-extract-plugin
export default {"wrap":"ShippingInfoDetailModal_wrap__f1OW7"};